export const PROGRAM_BENEFITS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_title: "",
    meta_title_color: "#FFFFFF",
    meta_sub_title: "",
    meta_sub_title_color: "#FFFFFF",
    meta_priority: "1",
    meta_card_blur_effect: false,
  },

  PROGRAM_BENEFITS_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: false,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "font_style",
      label: "Font Style",
      value: "var(--font-merriweather)",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Font Style",
      required: false,
      defaultValue: "var(--font-merriweather)",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Google Sans", value: "var(--font-google-sans)" },
        { label: "Merriweather", value: "var(--font-merriweather)" },
        { label: "Circular Std", value: "var(--font-circular-std)" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "rgba(0, 212, 235, 0.33)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "rgba(0, 212, 235, 0.33)",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "rgba(0, 0, 0, 0.66)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "rgba(0, 0, 0, 0.66)",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "rgba(0, 0, 0, 0.66)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "rgba(0, 0, 0, 0.66)",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "rgba(83, 69, 195, 0.46)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "rgba(83, 69, 195, 0.46)",
    },
    {
      fieldName: "pre_title",
      label: "Pre Title",
      value: "Graduate with globally recognized",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter pre title",
      required: false,
      defaultValue: "Why Choose ",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#222222CC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pre title color (e.g., #222222CC)",
      required: false,
      defaultValue: "#222222CC",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "This Program.",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter title",
      required: false,
      defaultValue: "This Program",
    },
    {
      fieldName: "title_start_color",
      label: "Title Start Color (Gradient)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_end_color",
      label: "Title End Color (Gradient)",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#00D4EB",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "title_gradient_direction",
      label: "Title Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g., '90deg'",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "description",
      label: "Description (max 250 characters)",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Max 250 characters. Leave empty to hide.",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#FFFFFFAF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFFAF",
      required: false,
      defaultValue: "#FFFFFFAF",
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button text",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "button_color",
      label: "Button Background Color",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#00D4EB",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "load_more_button",
      label: "Load More Button Text",
      value: "Load More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Load More button text",
      required: false,
      defaultValue: "Load More",
    },
    {
      fieldName: "load_more_button_text_color",
      label: "Load More Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Load More button text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "enable_animation",
      label: "Enable animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Scroll reveal on section content",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Program Benefits Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Program Benefits",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Image",
    },
    {
      header: "Alt Image",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #222222)",
      defaultValue: "#222222",
    },
    {
      header: "Sub Title",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Sub Title",
    },
    {
      header: "Sub Title Color",
      fieldName: "meta_sub_title_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter sub title color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: false,
    },
    {
      header: "Card Blur Effect",
      fieldName: "meta_card_blur_effect",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable blur effect on this card",
      defaultValue: false,
    },
  ]
};
